export const VERBAS = 'VERBAS';
export const VERBAS_START = 'VERBAS_START';
export const VERBAS_SUCCESS = 'VERBAS_SUCCESS';
export const VERBAS_ERROR = 'VERBAS_ERROR';

export const VERBAS_DETALHES = 'VERBAS_DETALHES';
export const VERBAS_DETALHES_START = 'VERBAS_DETALHES_START';
export const VERBAS_DETALHES_SUCCESS = 'VERBAS_DETALHES_SUCCESS';
export const VERBAS_DETALHES_ERROR = 'VERBAS_DETALHES_ERROR';
